<template>
  <header class="w-full flex items-center justify-between px-6 py-2 fixed">
    <router-link to="/">
      <img class="h-20" src="@/assets/images/logo.png" alt="Logo VarCast">
    </router-link>

      <horizontal-nav :menu="menu"></horizontal-nav>
      <select-language></select-language>
    <font-awesome-icon @click="toogleMenu" class="text-site-400 mx-2 text-2xl block lg:hidden"
          icon="bars" />
  </header>
    <vertical-nav :menu="menu"></vertical-nav>
</template>
<script>
import { menu } from '@/data/menu';
import VerticalNav from '@/components/header/VerticalNav.vue';
import HorizontalNav from '@/components/header/HorizontalNav.vue';
import SelectLanguage from '@/components/header/SelectLanguage.vue';

export default {
  name: 'HeaderBar',
  data() {
    return {
      menu,
    };
  },
  methods: {
    toogleMenu() {
      this.$store.dispatch('TOGGLE_MENU_STATE', { value: true });
    },
  },
  components: {
    VerticalNav,
    HorizontalNav,
    SelectLanguage,
  },
};
</script>
<style scoped>
</style>
